import { useLocation, useNavigate } from 'react-router-dom';
import { Music, LayoutGrid, ClipboardList, HelpCircle, Palette,Puzzle } from 'lucide-react';
import { useStore } from '../store/useStore';

const menuItems = [
  { path: '/my-dances', label: '我的舞蹈', icon: Music },
  // { path: '/plugins', label: '插件广场', icon: Puzzle },

  // { path: '/templates', label: '官方模板', icon: LayoutGrid },
  // { path: '/orders', label: '订单管理', icon: ClipboardList },
  // { path: '/help', label: '帮助中心', icon: HelpCircle },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { sidebarCollapsed, setSidebarCollapsed } = useStore();

  return (
    <aside
      className={`h-screen bg-sidebar flex flex-col transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] ${sidebarCollapsed ? 'w-[68px]' : 'w-[240px]'} shrink-0`}
      onMouseEnter={() => sidebarCollapsed && setSidebarCollapsed(false)}
      onMouseLeave={() => !sidebarCollapsed && setSidebarCollapsed(true)}
    >
      {/* Logo */}
      <div className="h-[60px] flex items-center px-5 border-b border-white/[0.05]">
        {!sidebarCollapsed && (
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 gradient-brand rounded-[12px] flex items-center justify-center shadow-lg shadow-brand/25 overflow-hidden">
              <img src="/assets/logo.png" alt="ODance" className="w-full h-full object-cover" />
            </div>
            <div className="flex flex-col">
              <span className="text-[16px] font-bold text-white tracking-tight">ODance</span>
              <span className="text-[9px] text-white/30 tracking-[0.15em] uppercase -mt-0.5">Robot Dance</span>
            </div>
          </div>
        )}
        {sidebarCollapsed && (
          <div className="w-9 h-9 gradient-brand rounded-[12px] flex items-center justify-center mx-auto shadow-lg shadow-brand/25 overflow-hidden">
            <img src="/assets/logo.png" alt="ODance" className="w-full h-full object-cover" />
          </div>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 py-4 px-3 space-y-0.5">
        {!sidebarCollapsed && (
          <div className="px-3 mb-2">
            <span className="text-[9px] font-semibold uppercase tracking-[0.2em] text-white/20">Navigation</span>
          </div>
        )}
        {menuItems.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              title={sidebarCollapsed ? item.label : undefined}
              className={`w-full flex items-center gap-3 px-3 py-[9px] rounded-[10px] text-[13px] font-medium transition-all duration-200 group relative ${
                isActive
                  ? 'text-white'
                  : 'text-white/40 hover:text-white/75 hover:bg-white/[0.04]'
              }`}
            >
              {/* Active indicator */}
              {isActive && (
                <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-5 bg-brand rounded-r-full" />
              )}
              {/* Active background glow */}
              {isActive && (
                <div className="absolute inset-0 bg-gradient-to-r from-brand/20 to-brand/5 rounded-[10px]" />
              )}
              <div className={`w-8 h-8 rounded-[9px] flex items-center justify-center transition-all duration-200 relative ${
                isActive
                  ? 'bg-brand/20'
                  : 'group-hover:bg-white/[0.06]'
              }`}>
                <Icon size={17} className={isActive ? 'text-brand-light' : ''} />
              </div>
              {!sidebarCollapsed && <span className="relative">{item.label}</span>}
            </button>
          );
        })}
      </nav>
    </aside>
  );
}
